import FixaSSRIcon from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/FixaSSRIcon";
import CircleFilledIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/CircleFilledIconPath";
import { ComponentNotificationTitleCreatorUserDrop } from "./types/task-notification.types";
import { getTitleAssignerString } from "./utils/task-notification-title";
import styles from "./task-notification.module.css";
import { useTranslation } from "@coworker/locales";

interface TaskNotificationTitleCreatorUserDropProps extends ComponentNotificationTitleCreatorUserDrop {
  read: boolean;
}
export const TaskNotificationTitleCreatorUserDrop = ({
  props: { assignedBy, assignedTo },
  read,
}: TaskNotificationTitleCreatorUserDropProps) => {
  const { t } = useTranslation();
  const assignedByString = getTitleAssignerString(assignedBy);
  const assignedToString = assignedTo.name;
  return (
    <div className={styles["task-notification-item-title"] ?? ""}>
      {!read && <FixaSSRIcon paths={CircleFilledIconPath} />}
      {t("hasDropTaskCreatedByYouString", {
        assignedBy: assignedByString,
        assignedTo: assignedToString,
      })}
    </div>
  );
};
